import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { DeviceInfoSetting, FocusInputType, InteractionType, KeyValues10, LocalService, Menus, PageKey, Status, SummaryType, TriggeredEvent } from '../../../service/local.service';
import { MenuManagementService } from '../../../service/menu-management.service';
import { DelivererConfigComponent } from '../../popups/deliverer-config/deliverer-config.component';
import { EditAdditionalDetailsComponent } from '../../popups/edit-additional-details/edit-additional-details.component';

@Component({
  selector: 'app-customize-menu',
  templateUrl: './customize-menu.component.html',
  styleUrls: ['./customize-menu.component.scss']
})
export class CustomizeMenuComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["menu_popup"]; items: Menus[]; excludedKeys: string[] = [PageKey.Logout.toString(), PageKey.CustomizeMenu.toString()];
  menusWithoutLogin: string[] = ['pricing-calculator', 'guide', 'rdir']; isPopupOpened = false; maxBodyHeight = 0;
  ctryCode: string = ''; userId: string = ''; interactionType: InteractionType; isSelf = false; pageKey: PageKey = PageKey.None; parentId = '';
  deviceId: string; businessId: string;

  isOpenUserAuthentication = false;

  constructor(public localService: LocalService, private router: Router, private modalService: NgbModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private menuManagementService: MenuManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      if (routeParams.deviceId) {
        this.deviceId = routeParams.deviceId;
      }
      if (routeParams.businessId) {
        this.businessId = routeParams.businessId;
      }
      this.onLoad();
    });
  }

  onLoad() {
    this.menuManagementService.getPublicMenus().subscribe(result => {
      this.items = result.menus;
      this.onLoadDeviceDetails();
    });
  }

  deviceInfo: DeviceInfoSetting;
  onLoadDeviceDetails() {
    this.configurationManagementService.getDeviceInfoSetting(this.deviceId, this.businessId).subscribe(result => {
      this.deviceInfo = result;
      this.items.forEach(item => {
        item.subMenus.forEach(subMenu => {
          subMenu.menu.isSelected = this.deviceInfo?.PageKeys?.includes(parseInt(subMenu.menu.v6));
        });
      });
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onAction(index: number, key1?: string, key2?: string) {
    switch (index) {
      case 1: {
        let selectedPageKeys: number[] = [];
        this.items.forEach(item => {
          item.subMenus.forEach(x => {
            if (x.menu.isSelected) {
              selectedPageKeys.push(parseInt(x.menu.v6));
            }
          });
        });

        this.deviceInfo.PageKeys = selectedPageKeys;
        this.configurationManagementService.saveDeviceInfoSetting(this.deviceInfo).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
        });
      } break;
      case 3: {
        if (key2) {
          const menu = this.items.find(item => item.menu.key == key1)?.subMenus.find(subMenu => subMenu.menu.key == key2)?.menu;
          if (menu) {
            menu.isSelected = !menu.isSelected;
          }
        }
      } break;
    }
  }
}
